import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../services/api";

export default function Login() {

  const [email,setEmail] = useState("");
  const [password,setPassword] = useState("");
  const [loading,setLoading] = useState(false);

  const login = async () => {

    if(!email || !password){
      alert("Please enter email and password");
      return;
    }

    try{

      setLoading(true);

      const res = await api.post("/auth/login",{ email,password });

      const user = res.data.user;

      const sessionData = {

        token: res.data.token,

        user_id: user.id,
        role: user.role,

        block_id: user.block_id || null,
        block_name: user.block_name || null,

        department_id: user.department_id || null,
        department_name: user.department_name || null,

        loginTime: Date.now()

      };

      sessionStorage.setItem("session",JSON.stringify(sessionData));

      /* =============================
         REDIRECT LOGIC (UPDATED)
      ============================= */

      if (user.role === "district_admin") {
        window.location = "/district";
        return;
      }

      if (user.role === "bdo") {
        window.location = "/bdo";
        return;
      }

      if (user.role === "department") {
  window.location = "/department-entry";
  return;
}

      window.location="/";

    }catch(err){

      console.error(err);

      if(err.response?.data?.msg){
        alert(err.response.data.msg);
      }else{
        alert("Login failed");
      }

    }finally{
      setLoading(false);
    }

  };

  
  return (

    <div className="min-h-screen bg-gradient-to-br from-pink-100 via-white to-indigo-100 flex items-center justify-center px-4">

      <div className="max-w-6xl w-full grid md:grid-cols-2 gap-10 items-center">

        {/* LEFT INFO SECTION */}

        <div className="text-center md:text-left">

          <div className="flex justify-center md:justify-start gap-4 mb-6">

            <img
              src="/Beti_Bachao_Beti_Padhao_logo.jpg"
              alt="Beti Bachao"
              className="w-16"
            />

            <img
              src="/bihar-logo.jpg"
              alt="Bihar Govt"
              className="w-20"
            />

            <img
              src="/bal bikas nigam logo.jpg"
              alt="Mahila Vikas"
              className="w-16"
            />

          </div>

          <h1 className="text-4xl font-bold text-red-700 mb-2">
            बेटी जन्मोत्सव
          </h1>

          <h2 className="text-2xl font-semibold text-gray-700 mb-2">
            कन्या रत्न सम्मान अभियान
          </h2>

          <p className="text-gray-600 mb-6">
            महिला एवं बाल विकास निगम, भोजपुर (आरा)
          </p>

          <p className="text-gray-500 leading-relaxed">
            यह पोर्टल जिला प्रशासन द्वारा संचालित योजनाओं की निगरानी,
            डेटा प्रबंधन और लाभार्थियों की प्रगति को ट्रैक करने के लिए
            विकसित किया गया है।
          </p>

          {/* HOME BUTTON */}

          <Link
            to="/"
            className="inline-block mt-6 bg-indigo-600 text-white px-6 py-3 rounded-lg shadow hover:bg-indigo-700 transition"
          >
            ← मुख्य पृष्ठ पर जाएँ
          </Link>

        </div>


        {/* LOGIN CARD */}

        <div className="bg-white shadow-2xl rounded-xl p-10 border-t-4 border-red-600">

          <h3 className="text-2xl font-bold text-center mb-6 text-gray-700">
            Portal Login
          </h3>

          {/* Email */}

          <div className="mb-4">

            <label className="text-gray-600 text-sm">
              Email
            </label>

            <input
              type="email"
              placeholder="Enter Email"
              className="w-full mt-1 border rounded-lg p-3 focus:ring-2 focus:ring-red-400 outline-none"
              value={email}
              onChange={(e)=>setEmail(e.target.value)}
              onKeyDown={(e)=>e.key==="Enter" && login()}
            />

          </div>

          {/* Password */}

          <div className="mb-6">

            <label className="text-gray-600 text-sm">
              Password
            </label>

            <input
              type="password"
              placeholder="Enter Password"
              className="w-full mt-1 border rounded-lg p-3 focus:ring-2 focus:ring-red-400 outline-none"
              value={password}
              onChange={(e)=>setPassword(e.target.value)}
              onKeyDown={(e)=>e.key==="Enter" && login()}
            />

          </div>

          {/* LOGIN BUTTON */}

          <button
            onClick={login}
            disabled={loading}
            className="w-full bg-red-600 hover:bg-red-700 text-white py-3 rounded-lg font-semibold transition shadow"
          >

            {loading ? "Logging in..." : "Login"}

          </button>

          <p className="text-center text-gray-400 text-sm mt-6">
            District Administration Bhojpur
          </p>

        </div>

      </div>

    </div>

  );

}